import { useContext } from 'react';
import { Button } from '@octano/global-ui';
import { Row, Col } from 'reactstrap';
import { useTranslation } from 'react-i18next';

import { CourseFormContext } from '../../providers/CourseProvider';
import { CourseFormMode } from '../../types';
import { TranslationsKeys } from '../../../../../locales/translations';

type CourseFooterSectionProps = {
  processing?: boolean;
  onCancel?: () => void;
  /** Si es false, se oculta el botón "Guardar" (solo lectura en el tab). */
  showSave?: boolean;
};

const CourseFooterSection = ({
  processing,
  onCancel,
  showSave = true,
}: CourseFooterSectionProps) => {
  const { t } = useTranslation(TranslationsKeys.ACADEMIC_OFFER_COURSES_UPDATE);

  const { mode, courseId } = useContext(CourseFormContext);

  if (mode === CourseFormMode.WATCH) {
    // En modo lectura aún queremos un botón "Cancelar" que vuelva al listado.
    if (!onCancel) {
      return <></>;
    }
    return (
      <Row className="py-5 justify-content-end pt-5">
        <Col xs={12} lg={3} className="pb-2">
          <Button
            type="button"
            outlined
            onClick={onCancel}
            text={t(`common:actions.cancel`)}
            disabled={!!processing}
            fullwidth
          />
        </Col>
      </Row>
    );
  }

  return (
    <Row className="py-5 justify-content-end pt-5">
      <Col xs={12} lg={3} className="pb-2 order-2 order-lg-1">
        <Button
          type="button"
          outlined
          onClick={onCancel}
          text={t(`common:actions.cancel`)}
          disabled={!!processing}
          fullwidth
        />
      </Col>
      {showSave && (
        <Col xs={12} lg={3} className="pb-2 order-1 order-lg-2">
          <Button
            type="submit"
            text={courseId ? t(`updateCourse`) : t(`createCourse`)}
            loading={!!processing}
            fullwidth
          />
        </Col>
      )}
    </Row>
  );
};

export default CourseFooterSection;
